var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import { Typography } from '../../Typography';
import "./styles.css";
export var Switch = React.forwardRef(function (_a, ref) {
    var label = _a.label, disabled = _a.disabled, className = _a.className, onChange = _a.onChange, props = __rest(_a, ["label", "disabled", "className", "onChange"]);
    return (React.createElement("label", { className: classNames('lk-ui_switch', disabled && 'lk-ui_switch__disabled', className) },
        React.createElement("input", __assign({ type: 'checkbox', disabled: disabled }, props, { ref: ref, className: 'lk-ui_switch-input' })),
        React.createElement("span", { className: 'lk-ui_switch-track' },
            React.createElement("span", { className: 'lk-ui_switch-slider round' })),
        label && (React.createElement(React.Fragment, null, typeof label === 'string' ? (React.createElement(Typography, { variant: 'body2', className: 'lk-ui_switch-label' }, label)) : (label)))));
});
